import WebIconConfiguration from './WebIconConfiguration';

export default WebIconConfiguration;
